import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectRetreatFlowing } from './selectors';
import { startRetreat } from './startRetreat';
import { selectActivePokemon, selectIsMainPhase, selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';
import { Button, Muted } from '../Controls';
import { EnergyCost } from '../Energy';

/** Starts a retreat (startRetreat). Dragging the active Pokémon onto a benched one starts one too. */
const RetreatButton = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const options = useSelector(selectOptions);
  const isMainPhase = useSelector((state) => selectIsMainPhase(state, { userId }));
  const retreatFlowing = useSelector(selectRetreatFlowing);

  if (!isMainPhase || !activePokemon) {
    return null;
  }

  const retreatCost = activePokemon.getIn(['card', 'retreat_cost']) || 0;
  // Whether it can retreat, and why not, is the server's call (asleep, no bench, not enough energy...).
  const reason = optionReason(options && options.get('retreat'));

  const start = () => startRetreat(dispatch, userId, retreatCost, activePokemon.get('energyAttachments'));

  return (
    <>
      <Button onClick={start} disabled={retreatFlowing || !!reason}>
        Retreat
        {retreatCost > 0 && <> <EnergyCost types={Array(retreatCost).fill('colorless')} /></>}
      </Button>
      {reason && <Muted>{reason}</Muted>}
    </>
  );
};

RetreatButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default RetreatButton;
